import { GET } from '../request'

export const getClasesFecha = ({ fecha }) =>
  GET('/api/profes/planificacion/clase-profesor', { fecha })

export const getClasesFechas = ({ fechaInicio, fechaFin }) =>
  GET('/api/profes/planificacion/clase-profesor/list', {
    fechaInicio,
    fechaFin
  })
